module.exports = __webpack_public_path__ + "static/media/tiktok.7ab572f5.svg";